import { Component, Input, OnInit } from '@angular/core';
import { advertisement, ServiceService, CatMetricTypes } from 'src/app/service.service';
import { ModalController, LoadingController, AlertController, IonInfiniteScroll, Platform } from '@ionic/angular';
import { ModalPollPage } from '../../modalpoll/modalpoll.page';

@Component({
  selector: 'app-section-advertisements',
  templateUrl: './section-advertisements.component.html',
  styleUrls: ['./section-advertisements.component.scss'],
})
export class SectionAdvertisementsComponent implements OnInit {
  @Input() advertisements:advertisement;
  constructor(public modalController: ModalController,public services: ServiceService) { }

  ngOnInit() {
  }

  isQuestions(advertisement:any){
    if(advertisement?.questionsAds && advertisement.questionsAds.length > 0 && advertisement.metric_id == 4){
      return true;
    }
    return false;
  }

  isLink(advertisement:any){
    if(advertisement?.metric_id == 3  && advertisement?.link != ''){
      return true;
    }
    return false;
  }

  openLink(advertisement:any){
    if(advertisement.link != null){
      let metrica = advertisement.metricsAds.find(m=>m.metricId==CatMetricTypes.CPC);
      if(metrica && metrica.relAdsMetricsId){
        this.services.postAdvertisementUser([metrica.relAdsMetricsId]);
        window.open(advertisement.link, '_blank');
      }
    }
  }
  
  async openAdvertisement(advertisement:any){
    const modal = await this.modalController.create({
      component: ModalPollPage,
      cssClass:(!this.services.isMovil())?'custom-modal':'',
      componentProps: {
        'advertisement': advertisement
      }
    });
    modal.onDidDismiss().then(async data => {
      //await this.loadPosts();
    });
    return await modal.present();
  }

  openLinkOrQuestions(advertisement:any){
    if(this.isQuestions(advertisement)){
      this.openAdvertisement(advertisement);
    }else if(this.isLink(advertisement)){
      this.openLink(advertisement)
    }
  }
}
